import { Outlet, useLocation } from "react-router";
import { useEffect } from "react";
import Header from "../core/common/header/header";
import BackToTop from "../core/common/backtotop/backToTop";
import Footer from "../core/common/footer/footer";

const Feature = () => {

  const location = useLocation();


  useEffect(() => {

    window.scrollTo(0, 0);
  }, [location.pathname])

  return (
    <>

      <div className="main-wrapper">
        <div >
          <Header />
          <Outlet />
          <Footer />
          <BackToTop />
        </div>

        <div className="sidebar-overlay"></div>
      </div>
    </>
  );
};

export default Feature;
